<div class="deactivate-school-dialog">

  <h1 mat-dialog-title class="dialog-title">Deactivate school account</h1>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-warning">Deactivating your school account cannot be undone.</p>
    <ul class="dialog-effects">
      <li>All pupils are unlinked from the school and school restrictions stop at once.</li>
      <li>Staff will no longer be able to sign in.</li>
      <li>The school's data is deleted within one day. Family accounts stay with the parents.</li>
      <li>If you use Wonde, remove LOQT from your Wonde account.</li>
    </ul>

    <p class="dialog-message">Type the school name to confirm.</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>School name</mat-label>
      <input matInput [(ngModel)]="typedName" [placeholder]="data.schoolName" autocomplete="off"
             data-testid="deactivate-school-name-input">
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancel()" data-testid="deactivate-school-cancel">Cancel</button>
    <button mat-flat-button color="warn" [disabled]="!nameMatches" (click)="confirm()"
            data-testid="deactivate-school-confirm">
      Deactivate school account
    </button>
  </mat-dialog-actions>
</div>
